import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { ScoreBarChart } from "../../../components/ScoreBarChart";
import QuodSvg from "../../../assets/quod.svg";
 
 
export default function ScoreInadimplenciaPJ({
  scoreInadimplenciaPJ,
}: {
    scoreInadimplenciaPJ: any;
}) {
  const { t } = useTranslation();
 
  const topMarkers = [
    '0', '1', '2-40', '41-80', '81-99', '100'
  ];
 
  const bottomLabels = [
    "Baixa gravidade no atraso",
    "Média gravidade no atraso",
    "Alta gravidade no atraso"
  ];
 
  const iconRender = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <img className="quod-svg" src={QuodSvg} alt="Quod Logo" />
        {t("inadimplenciaPJ")}
      </div>
    );
  };
 
  return (
    <Panel header={iconRender()} className="content-width" toggleable>
      <ScoreBarChart
        score={scoreInadimplenciaPJ.valor}
        topMarkers={topMarkers}
        bottomLabels={bottomLabels}
        reverse={true}
        maxScore={100}
      />
 
      <div style={{ marginTop: "2rem" }}>{scoreInadimplenciaPJ.mensagem}</div>
      <div><b>Porte:</b> {scoreInadimplenciaPJ.porte}</div>
    </Panel>
  );
}